// Display helpers for the upload-time estimates (the /web-uploader estimator and the uploader's comparison).
import type { RoundedDuration } from "./uploadEstimate";

/** "{name}" placeholders filled from `vars` (unknown names are left as they are). */
export const fill = (s: string, vars: Record<string, string | number>): string =>
  s.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));

/** Numbers the way the site writes them: "10,000" in English, "10 000" (non-breaking) in Spanish and
 *  Portuguese, the locale's own way elsewhere. */
export const formatNumber = (n: number, lang: string, maxFractionDigits = 1): string => {
  const en = n.toLocaleString("en-US", { maximumFractionDigits: maxFractionDigits });
  if (lang === "en") return en;
  if (lang === "es" || lang === "pt") return en.replace(/,/g, " ").replace(/\.(\d)/, ",$1");
  return n.toLocaleString(lang, { maximumFractionDigits: maxFractionDigits });
};

/** Time templates: { under: "under a minute", min: "about {n} min", h: "about {n} h", d: "about {n} days" }. */
export type TimeCopy = { under: string; min: string; h: string; d: string };

export const formatDuration = (d: RoundedDuration, t: TimeCopy, lang: string): string =>
  d.unit === "under" ? t.under : fill(t[d.unit], { n: formatNumber(d.n, lang) });
